'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var Provider = {};

exports.__exports = Provider;
